import WorkspaceLink from '../workspace/WorkspaceLink';
import { getPeopleWorkspaceView, PEOPLE_WORKSPACE_VIEWS, resolvePeopleWorkspaceView } from '../../lib/peopleWorkspace';
import { cn } from '../../lib/utils';

export default function PeopleWorkspaceShell({
  activeView,
  pathname = '',
  search = '',
  title,
  description,
  actions,
  children,
}) {
  const resolvedViewId = activeView || resolvePeopleWorkspaceView(pathname, search);
  const currentView = getPeopleWorkspaceView(resolvedViewId);

  return (
    <section className="space-y-6" data-testid="people-workspace-shell">
      <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div className="flex flex-col gap-5 lg:flex-row lg:items-start lg:justify-between">
          <div className="min-w-0 flex-1">
            <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">People</p>
            <div className="mt-1 flex flex-wrap items-center gap-3">
              <h1 className="font-heading text-2xl font-bold text-slate-950 sm:text-3xl">
                {title || currentView.title}
              </h1>
            </div>
            {(description || currentView.description) && (
              <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-600">
                {description || currentView.description}
              </p>
            )}
          </div>
          {actions && (
            <div className="flex shrink-0 flex-wrap items-center gap-2" data-testid="people-workspace-actions">
              {actions}
            </div>
          )}
        </div>

        <nav className="mt-5 overflow-x-auto" aria-label="People workspace views">
          <div className="flex min-w-max gap-2 rounded-2xl bg-slate-100 p-1">
            {PEOPLE_WORKSPACE_VIEWS.map((view) => {
              const selected = view.id === resolvedViewId;
              return (
                <WorkspaceLink
                  key={view.id}
                  to={view.href}
                  aria-current={selected ? 'page' : undefined}
                  className={cn(
                    'rounded-xl px-3 py-2 text-sm font-medium text-slate-600 transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0F766E]',
                    selected
                      ? 'bg-white text-slate-950 shadow-sm'
                      : 'hover:bg-white/70 hover:text-slate-950'
                  )}
                >
                  {view.label}
                </WorkspaceLink>
              );
            })}
          </div>
        </nav>
      </div>

      {children}
    </section>
  );
}
